import cn from 'classnames';

import { ArticleBasedVoucher } from '@zooplus/checkout-state';
import { InfoTag } from '@zooplus/ui-components';

import { useTranslation } from '@hooks/use-translations';

import styles from './item-based-discount.module.scss';

const ItemBasedDiscount = (abdDetails: ArticleBasedVoucher) => {
  const { t } = useTranslation();
  const { isPersonalized, voucherLabel } = abdDetails;
  return (
    <InfoTag
      variant="primary"
      data-testid="article-based-discount"
      className={cn(isPersonalized && styles.personalizedABDWrapper)}>
      {isPersonalized && (
        <svg
          width="18px"
          height="15px"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 512 512"
          className={styles.personalizedABDIcon}>
          <g>
            <g>
              <path
                d="M393.983,154.726c-4.378-8.55-13.175-13.926-22.784-13.926h-53.052l38.716-106.453c2.85-7.851,1.698-16.597-3.089-23.433
                C348.978,4.07,341.153,0,332.799,0h-140.8c-11.75,0-21.99,7.996-24.832,19.388l-51.2,204.8
                c-1.911,7.646-0.196,15.753,4.659,21.965c4.847,6.212,12.288,9.847,20.173,9.847h53.521l-77.679,221.944
                c-4.207,12.006,1.05,25.284,12.331,31.164c3.763,1.954,7.808,2.893,11.81,2.893c8.013,0,15.838-3.763,20.787-10.641l230.4-320
                C397.592,173.56,398.369,163.277,393.983,154.726z M140.799,486.4l89.6-256h-89.6l51.2-204.8h140.8l-51.2,140.8h89.6
                L140.799,486.4z"
              />
            </g>
          </g>
        </svg>
      )}
      {isPersonalized
        ? t('cart.product.personalised.discount', { 0: voucherLabel })
        : t('cart.product.discount', { 0: voucherLabel })}
    </InfoTag>
  );
};

export default ItemBasedDiscount;
